import React from 'react';
import InframailIpsContent from './components/inframail-ips-content';

const InframailIps: React.FC = () => (
  <div className="inframailIps-container">
    <InframailIpsContent />
  </div>
);

export default InframailIps;
